import React, { useEffect, useState } from 'react'
import SearchField from '../../elements/SearchField'
import ModalDialog from '../../layouts/ModalDialog'
import NewStudentFeedback from './NewStudentFeedback'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../elements/Loader'
import DataTable from '../../elements/DataTable'
import EmptyState from '../../elements/EmptyState'
import { tableHeadersFields } from '../../../utils'
import { clearCreatedStudentFeedback, fetchStudentFeedback } from '../../../store/actions/studentFeedbackActions'
import { Link } from 'react-router-dom'
import moment from 'moment/moment'
import ArrowIcon from '../../elements/icons/ArrowIcon'

const StudentFeedback = ({student}) => {
  const [addingFeedback, setAddingFeedback] = useState(false)
  const feedbackSelector = useSelector(state => state.feedback)

  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 25
  })

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchStudentFeedback(`student=${student._id}`, pagination.page, pagination.perPage))
    if(feedbackSelector.createdStudentFeedback !== null) {
      dispatch(clearCreatedStudentFeedback())
      setAddingFeedback(false)
    }
  
    return () => {
      
    }
  }, [dispatch, feedbackSelector.createdStudentFeedback, pagination.page, pagination.perPage, student._id])
  

  const columnWidths = {
    excerpt: 'w-8/12',
    date: 'w-3/12',
    '': 'w-1/12'
  }
        
  const tableOptions = {
    selectable: false,
    clickableRows: true,
    rowAction: (index)=>{}
  }
  
  const columnDataStyles = {}
  
  const cleanupData = (dataSet) => {
    if(!dataSet) return []
    const data = []
    dataSet.forEach((item, itemIndex) => {
      data.push(
        {
          excerpt: <div>
              <p className='text-sm text-gray-700'>{item.excerpt}</p>
              <p className='text-sm mt-[10px] font-[500]'><span className='text-gray-500 font-[400]'>Created by:</span> <Link className='text-gray-600 font-[550]' to={`/admin/college-staff/${item.createdBy._id}`}>{`${item.createdBy?.fullName}`}</Link></p>
              {/* <p className='text-sm text-gray-500'>{staff.email}, {staff?.phone}</p> */}
            </div>,
          // createdBy: <Link to={`/admin/college-staff/${item.createdBy._id}`}><StaffTableSnippet staff={item.createdBy} /></Link>,
          date: <p className='text-sm text-gray-600'>{moment(item.createdAt).format('MMMM Do YYYY')}<br/><span className='text-gray-400 text-xs'>{moment(item.createdAt).format('h:mm a')}</span></p>,
          '': <button onClick={()=>{openFeedback(item)}} className='flex items-center justify-center gap-x-[5px] text-sm font-space-grotesk font-[500]'>Read more <ArrowIcon className={`w-3 h-3`} />  </button>
        },
      )
    })

    return data
  }

  const [readingFeedback, setReadingFeedback] = useState(false)
  const [activeFeedback, setActiveFeedback] = useState(null)

  const openFeedback = (feedback) => {
    setActiveFeedback(feedback)
    setTimeout(() => {
      setReadingFeedback(true)
    }, 200);
  }

  const closeFeedback = () => {
    setReadingFeedback(false)
    setTimeout(() => {
      setActiveFeedback(false)
    }, 200);
  }

  return (
    <>
      <div className="w-full">
        <div className='pb-3 mb-2'>
            <div className="w-full mx-auto">
                <div className='w-full flex items-center justify-between'>
                  <div className='w-2/3'>
                    <h4 className='font-medium text-lg text-gray-700'>College staff feedback on {student.firstName}</h4>
                    <div className=''>
                      <p className='text-gray-500 mt-1 text-sm'>
                        Below is a list of feedback from college staff for this student
                      </p>
                    </div>
                  </div>
                  <button onClick={()=>{setAddingFeedback(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                    Add feedback for this student
                  </button>
                </div>

                <div className='w-full flex items-center justify-between my-5 p-2 rounded-md border'>
                    <div className='w-full'>
                        {/* <InvoicesFilters applyFilters={(filters)=>{
                            console.log('filters => ', filters)
                            setFilters(filters)
                        }} 
                        /> */}
                    </div>
                    <div className='w-full flex flex-row-reverse gap-x-2'>
                        <div className='w-[350px]'>
                            <SearchField 
                                placeholderText={`Search for feedback`}
                                showResultsDropDown={false}
                                triggerSearch={(term)=>{}}
                                performingSearch={false}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className=''>
          {feedbackSelector?.loadingStudentFeedback
          ? 
            <div className='w-full'>
                <Loader />
            </div>
          : 
            feedbackSelector?.studentFeedback?.feedbacks?.length > 0 ? <>
              <DataTable
                tableHeaders={tableHeadersFields(cleanupData(feedbackSelector?.studentFeedback?.feedbacks)[0]).headers} 
                tableData={cleanupData(feedbackSelector?.studentFeedback?.feedbacks)} 
                columnWidths={columnWidths}
                columnDataStyles={columnDataStyles}
                allFields={tableHeadersFields(cleanupData(feedbackSelector?.studentFeedback?.feedbacks)[0]).fields}
                onSelectItems={()=>{}}
                tableOptions={tableOptions}
                pagination={{
                  perPage: pagination.perPage, 
                  currentPage: pagination.page,
                  totalItems: feedbackSelector.studentFeedback?.total,
                }}
                changePage={(page) => {setPagination({...pagination, ...{page: page}})}}
                updatePerPage={(perPage) => {setPagination({...pagination, ...{perPage: perPage}})}}
              />
            </>
            :
            <div>
              <EmptyState emptyStateText={`No feedback created for ${student.firstName} ${student.lastName} yet`} />
            </div>
          }
        </div>
      </div>

      <ModalDialog
        shown={addingFeedback} 
        closeFunction={()=>{setAddingFeedback(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle={`Add feedback for ${student.fullName}`}
        maxWidthClass='max-w-2xl'
        hideActions={true}
      >
        <NewStudentFeedback 
          close={()=>{setAddingFeedback(false)}}
          student={student._id}
        />
      </ModalDialog>

      {activeFeedback && <ModalDialog
        shown={readingFeedback} 
        closeFunction={()=>{closeFeedback()}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle={`feedback for ${student.fullName}`}
        maxWidthClass='max-w-2xl'
        hideActions={true}
      >
        <div className='p-[20px]'>
          <div dangerouslySetInnerHTML={{__html: activeFeedback.feedback}} />
        </div>
      </ModalDialog>}
    </>
  )
}

export default StudentFeedback